"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function findKey(subject, predicate, thisArg) {
    return Object.keys(subject).find(predicate, thisArg);
}
exports.findKey = findKey;
//# sourceMappingURL=findKey.js.map